














































































































import { createComponent, computed, ref, onUpdated } from '@vue/composition-api'
import copy from 'copy-to-clipboard'
import { getFactoryStatus, getStatusBorderColor } from '@/lib/map'
import { getFactoryTypeText } from '@/lib/factory'
import useScroll from '@/lib/hooks/useScroll'

import { useAppState } from '../lib/appState'
import { FactoryImage, getDisplayStatusText } from '../types'

export default createComponent({
  name: 'FactoryDetailPage',
  setup () {
    const [appState, { pageTransition, expandFactoryDetail, collapseFactoryDetail, toggleFactoryDetail }] = useAppState()

    const images = computed(() => {
      if (appState.factoryData) {
        return appState.factoryData.images
      } else {
        return []
      }
    })

    const factoryStatus = computed(() => {
      if (appState.factoryData) {
        return getFactoryStatus(appState.factoryData)
      } else {
        return undefined
      }
    })

    const factoryStatusText = computed(() => {
      if (typeof factoryStatus.value !== 'undefined') {
        return getDisplayStatusText(factoryStatus.value)
      } else {
        return ''
      }
    })

    const statusColor = computed(() => {
      if (typeof factoryStatus.value !== 'undefined') {
        return getStatusBorderColor(factoryStatus.value)
      } else {
        return null
      }
    })

    const factoryId = computed(() => {
      if (appState.factoryData) {
        return appState.factoryData.display_number
      } else {
        return ''
      }
    })

    const factoryType = computed(() => {
      if (appState.factoryData) {
        return getFactoryTypeText(appState.factoryData)
      }
    })

    const factoryName = computed(() => {
      return appState.factoryData?.name
    })

    const full = computed(() => appState.factoryDetailsExpanded)

    const longitude = computed(() => appState.factoryData?.lng.toFixed(7))
    const latitude = computed(() => appState.factoryData?.lat.toFixed(7))

    const factoryDetailScrollerRef = ref(null)
    const { scrollTop } = useScroll(factoryDetailScrollerRef)
    const scrollOff = computed(() => scrollTop.value > 29 && full.value)

    const showCopiedMessage = ref(false)
    const copyToClipboard = () => {
      if (!appState.factoryData) {
        return
      }

      const { host, protocol } = window.location
      const url = `${protocol}//${host}/#map=16/${appState.factoryData?.lng}/${appState.factoryData?.lat}`

      copy(url)

      showCopiedMessage.value = true
      window.setTimeout(() => {
        showCopiedMessage.value = false
      }, 1000)
    }

    // Workaround https://github.com/vuetifyjs/vuetify/issues/10971
    const slideGroup = ref(null)
    let prevImages: FactoryImage[]
    onUpdated(() => {
      if (JSON.stringify(images.value) === JSON.stringify(prevImages)) {
        return
      } else {
        if (!prevImages) {
          prevImages = images.value.slice()
          return
        } else {
          prevImages = images.value.slice()
        }
      }

      if (!slideGroup.value) {
        return
      }

      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      const content = (slideGroup.value as any)?.$refs.content
      window.setTimeout(() => {
        content.style = 'translateX(0px)'
      }, 50)
    })

    const startUpdateFactoryCommentFor = (field = 'others') => {
      pageTransition.startUpdateFactoryComment(field)
    }

    return {
      full,
      appState,
      pageTransition,
      images,
      expandFactoryDetail,
      collapseFactoryDetail,
      toggleFactoryDetail,
      factoryStatus,
      factoryStatusText,
      statusColor,
      factoryId,
      factoryType,
      factoryName,
      longitude,
      latitude,
      factoryDetailScrollerRef,
      scrollOff,
      showCopiedMessage,
      copyToClipboard,
      slideGroup,
      startUpdateFactoryCommentFor
    }
  }
})
